import React from 'react';
import styled, { css } from 'styled-components';

import { ClickAwayListener } from '@material-ui/core';

interface PopupProps {
  open?: boolean;
  children?: JSX.Element;
  setOpen?: any;
  simple?: boolean;
  pos?: 'top' | 'middle' | 'bottom';
}

const PopupDialog = styled.div`
  box-sizing: border-box;
  margin: 0 21px;
  position: relative;
`;
const PopupContainer = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  word-break: keep-all;
  word-wrap: break-word;
`;

const BackGround = styled.div<PopupProps>`
  display: ${props => (props.open ? 'block' : 'none')};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 190;
  background: #000;
  opacity: 0.8;
  width: 100%;
  height: 100%;
`;

const PopupWrap = styled.div<PopupProps & { simple?: boolean }>`
  display: ${props => (props.open ? 'flex' : 'none')};

  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  overflow: hidden;
  z-index: 200;
  text-align: center;
  &.top {
    justify-content: flex-start;
  }
  &.middle {
    justify-content: center;
  }
  &.bottom {
    justify-content: flex-end;
  }

  ${props =>
    props.simple &&
    css`
      ${PopupContainer} {
        background-color: transparent;
      }

      ${PopupDialog} {
        margin: 0;
      }
    `};
`;

const Popup: React.FC<PopupProps> = ({ open, children, setOpen, pos, simple }) => {
  const handleClickAway = () => {
    if (open) {
    }
  };

  return (
    <>
      <PopupWrap simple={simple} className={`popup-wrap ${pos ? pos : ''}`} open={open}>
        <PopupDialog>
          <ClickAwayListener onClickAway={handleClickAway}>
            <PopupContainer>{children}</PopupContainer>
          </ClickAwayListener>
        </PopupDialog>
      </PopupWrap>
      <BackGround open={open} className="dimm"></BackGround>
    </>
  );
};

export default Popup;
